import {organisers} from "./channelOrganiser";

let mainRoute = "/application/channelDashboard";

const ChannelRoutes = {
  getStarted:{
    heading: "",
    title:"Course Essentials",
    description: "Find course curriculum, student assessment framework and other such essentials to get started.",
    //status: { text: "75% Complete", percentage:75 },
    status: null,
    badges: null,
    icon: "https://p14cdn4static.sharpschool.com/UserFiles/Servers/Server_1951494/Image/News/Whats%20New/essential.jpg",
    organisers: organisers.os_001
  },howToConduct:{
    heading:"",
    title: "How to conduct guides",
    description: "Process guides, facilitation guides, class presentations to help you conduct your class systematically.",
    status: null,
    badges: null,
    icon:"https://cms-assets.tutsplus.com/uploads/users/23/posts/27281/preview_image/creative-presentation-ideas-to-inspire-action.png",
    organisers: organisers.os_002
  },goingDeeper:{
    heading:"",
    title: "Deepening resources",
    description: "Strengthen your foundation in the course with the help of concept videos, exploratory notes, articles, etc.",
    status: null,
    badges: null,
    icon:"https://vignette.wikia.nocookie.net/doawk/images/0/01/READING_IS_FUN.png/revision/latest?cb=20130510130610",
    organisers: organisers.os_003
  },reports:{
    heading:"Analytics",
    title: "Analytics",
    description: "How are your students doing in the course? Where can you focus to help your students? These and other such statistics and insights to help you.",
    status: null,
    badges: null,
    icon:"https://subiz.com/img/report.png",
    organisers: organisers.os_004
  }
};

Object.keys(ChannelRoutes).forEach((key, i)=>{
  ChannelRoutes[key].route = mainRoute+"/"+key;
});

export {ChannelRoutes}





// WEBPACK FOOTER //
// ./src/modal/channelRoutes.js